// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qv-9";
export var arrowButtonContainer = "_qv-5";
export var arrowButtonIcon = "_qv-6";
export var carouselArrowButton = "_qv-2";
export var carouselElementContainer = "_qv-1";
export var currentSlide = "_qv-8";
export var left = "_qv-3";
export var otherSlide = "_qv-a";
export var productCarouselContainer = "_qv-0";
export var right = "_qv-4";
export var sliderOverflow = "_qv-7";